import React, { useState, useEffect, useRef } from "react";
import TableStyle from "./Content/Table/TableStyle.module.css";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Grid } from "@mui/material";
import moment from "moment";
import { Utils } from "common/Utils";

function HWStatementDetail ({delay, statementDetails,time ,statementDisclaimers }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
      const timeout = setTimeout(() => {
        setVisible(true)
      }, delay)
  
      return () => clearTimeout(timeout)
    })
    
    let divStyle = {marginBottom: "75px", display:(visible?"":"none")}
    //let divStyle = {marginBottom: "75px"}
    let contractGroup = []
    let contractPerRow = 4
    for (let c = 0; c < statementDetails.contracts.length; c = c + contractPerRow) {
      contractGroup.push(statementDetails.contracts.slice(c, c + contractPerRow))
    }
    return (
      <div
        className={`${TableStyle.hwWrapper} statement`}
        style={divStyle}
        //ref={statementRef}
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCell
                style={{ fontWeight: "500", padding: "5px" }}
                className="pdf-left"
              >
                {`${statementDetails && statementDetails.lastName}, ${statementDetails && statementDetails.firstName}`}
              </TableCell>
              <TableCell
                align="right"
                style={{ fontWeight: "500", padding: "5px" }}
              >
                {statementDetails.companyName} H&amp;W Benefit Statement {statementDetails.timePeriod} {moment(statementDetails.payDate).format("MMMM DD, YYYY")}{statementDetails.endDate ? ` - ${moment(statementDetails.endDate).format("MMMM DD, YYYY")}` : ''}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {/* CONTRACTS */}
        {contractGroup.map((contracts) => {
          return (
            <TableContainer className={TableStyle.hwTwoColWrapper}>
              <Table>
                <TableBody>
                  {/* CONTRACT CODE */}
                  <TableRow>
                    <TableCell className={`${TableStyle.firstTd} pdf-right`} scope="row" align="right">
                      Contract Code
                    </TableCell>
                    {/* {statementDetails.contracts[i].contractCode} */}
                    {contracts.map((contract, i) => {
                      return (
                        <TableCell align="right" className={ (contracts.length==1?TableStyle.dataTd30:TableStyle.dataTd20)} >
                          {contract.contractCode}
                        </TableCell>
                      );
                    })
                    }
                  </TableRow>
                  {/* Hours */}
                  {
                    statementDetails.hourTypes.map(
                      (hourNameType, k) => {
                        return (
                          <TableRow>

                            <TableCell className={TableStyle.firstTd}
                              scope="row"
                              align="right"
                            >
                              {hourNameType}
                            </TableCell>
                            {contracts.map((contract, i) => {
                              let hours = 0
                              contract.hours.filter(h => h.name == hourNameType).map(item => {
                                hours += item.amount
                              })
                              return (
                                <TableCell align="right" className={ (contracts.length==1?TableStyle.dataTd30:TableStyle.dataTd20)} >
                                  {Utils.roundToTwo(hours)}
                                </TableCell>
                              );
                            }
                            )}
                          </TableRow>
                        )
                      }
                    )}
                  {/* Total Hours */}
                  <TableRow>
                    <TableCell className={TableStyle.firstTd} scope="row" align="right">
                      Total Hours
                    </TableCell>

                    {contracts.map((contract, i) => {
                      let totalHours = 0
                      contract.hours.map(item => {
                        totalHours += item.amount
                      })
                      return (
                        <TableCell align="right" className={ (contracts.length==1?TableStyle.dataTd30:TableStyle.dataTd20)} >
                          {Utils.roundToTwo(totalHours)}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                  {/* H&W Fringe Rate */}
                  <TableRow>
                    <TableCell className={TableStyle.firstTd} scope="row" align="right">
                      H&W Fringe Rate
                    </TableCell>
                    {contracts.map((contract, i) => {
                      return (
                        <TableCell align="right" className={ (contracts.length==1?TableStyle.dataTd30:TableStyle.dataTd20)} >
                          {Utils.formatCurrency(contract.fringeRate)}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                  {/* H&W Due to Employee */}
                  <TableRow>
                    <TableCell className={TableStyle.firstTd} scope="row" align="right">
                      H&W Due to Employee
                    </TableCell>
                    {contracts.map((contract, i) => {
                      return (
                        <TableCell align="right" className={ (contracts.length==1?TableStyle.dataTd30:TableStyle.dataTd20)} >
                          {Utils.formatCurrency(contract.totalHWDue)}
                        </TableCell>
                      );
                    })}
                  </TableRow>

                </TableBody>
              </Table>
            </TableContainer>
          )
        })}
        <TableContainer className={TableStyle.hwOneRcd}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  align="right"
                  style={{ width: "66.6%" }}
                  className="pdf-right"
                >
                  H&W Due to Employee Total
                </TableCell>
                <TableCell align="right">
                  {Utils.formatCurrency(statementDetails.totalHwDue)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* COSTS */}
        <TableContainer className={TableStyle.hwThreeColRcdWrapper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "33%" }}>
                  H&W Costs
                </TableCell>
                <TableCell style={{ width: "33%" }}>
                  Description
                </TableCell>
                <TableCell style={{ width: "33%" }}>
                  Full Cost/Mo
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {statementDetails.benefitCost.map(
                (eeCostDetails) =>
                  eeCostDetails.doDisplayEECost && (
                    <TableRow>
                      <TableCell className="pdf-left">
                        {eeCostDetails.eeCostLabel}
                      </TableCell>
                      <TableCell className="pdf-left">
                        {eeCostDetails.eeCostDescription}
                      </TableCell>
                      <TableCell align="right">
                        {Utils.formatCurrency(eeCostDetails.totalCost)}
                      </TableCell>
                    </TableRow>
                  )
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* H&W COST */}
        <TableContainer className={TableStyle.hwOneRcd}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  align="right"
                  style={{ width: "66.6%" }}
                  className="pdf-right"
                >
                  H&W Cost
                </TableCell>
                <TableCell align="right">
                  {Utils.formatCurrency(statementDetails.totalBenefitCost)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {/* EE CREDIT */}
        <TableContainer className={TableStyle.hwThreeColRcdWrapper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "33%" }}>
                  H&W Credits
                </TableCell>
                <TableCell style={{ width: "33%" }}>
                  Description
                </TableCell>
                <TableCell style={{ width: "33%" }} align="right" className="pdf-right">Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* statementDetails.benefitCost.doDisplayEECost === true ?  */}
              {statementDetails.benefitCost.map(
                (eeCreditDetails) =>
                  eeCreditDetails.doDisplayCredit && (
                    <TableRow>
                      <TableCell className="pdf-left">
                        {eeCreditDetails.creditLabel}
                      </TableCell>
                      <TableCell className="pdf-left">
                        {eeCreditDetails.creditDescription}
                      </TableCell>
                      <TableCell align="right">
                        {Utils.formatCurrency(eeCreditDetails.erCost)}
                      </TableCell>
                    </TableRow>
                  )
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* H&W Credits */}
        <TableContainer className={TableStyle.hwOneRcd}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  align="right"
                  style={{ width: "66.6%" }}
                  className="pdf-right"
                >
                  H&W Credits
                </TableCell>
                <TableCell align="right">
                  {Utils.formatCurrency(statementDetails.totalHWCredit)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {/* H&W Amount Due - H&W Credits */}
        <TableContainer className={TableStyle.hwOneRcd}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  align="right"
                  style={{ width: "66.6%" }}
                  className="pdf-right"
                >
                  H&W Amount Due - H&W Credits
                </TableCell>
                <TableCell align="right">
                  {Utils.formatCurrency(statementDetails.netHWDue)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* Hourbank Used */}
        {statementDetails.hourBankUsed !== 0 ? (
          <TableContainer className={TableStyle.hwOneRcd}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    align="right"
                    style={{ width: "66.6%" }}
                    className="pdf-right"
                  >
                    Hourbank Used
                  </TableCell>
                  <TableCell align="right">
                    {Utils.formatCurrency(statementDetails.hourBankUsed)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          ""
        )}

        {/* Hourbank amount used to cover shortages */}
        {statementDetails.fringeExcessAllocation.map(
          (excessAllocationHB) => {
            if (
              excessAllocationHB.name === "Hourbank" &&
              excessAllocationHB.amount < 0
            ) {
              var excessAllocationHBAmount =
                excessAllocationHB.amount;

              excessAllocationHBAmount *= -1; // change negative value to positive of Hourbank Amount
              return (
                <TableContainer className={TableStyle.hwOneRcd}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          component="th"
                          scope="row"
                          align="right"
                          style={{ width: "66.6%" }}
                          className="pdf-right"
                        >
                          Hourbank amount used to cover shortages
                        </TableCell>
                        <TableCell align="right">
                          {Utils.formatCurrency(excessAllocationHBAmount)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              );
            }
          }
        )}

        {/* Contribution to 'fringeExcessAllocationDetails.name' from H&W */}
        <TableContainer
          className={`${TableStyle.hwOneRcd} ${TableStyle.hwOneRcdIterate}`}
        >
          <Table>
            <TableBody>
              {statementDetails.fringeExcessAllocation.map(
                (fringeExcessAllocationDetails) => {
                  return (
                    <TableRow
                      className={TableStyle.contributionWrapper}
                      style={{ borderSpacing: "5px" }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        align="right"
                        style={{ width: "66.6%" }}
                        className="pdf-right"
                      >
                        {`Contribution to ${fringeExcessAllocationDetails.name} from H&W`}
                      </TableCell>
                      <TableCell align="right">
                        {Utils.formatCurrency(fringeExcessAllocationDetails.amount)}
                      </TableCell>
                    </TableRow>
                    // <br></br>
                  );
                }
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Additional Contribution to 'fringeExcessAllocationDetails.name' from H&W */}

        {statementDetails.fringeExcessAllocationAdditional.map(
          (fringeExcessAllocationAdditionalDetails) => {
            return (
              <TableContainer
                className={`${TableStyle.hwOneRcd} ${TableStyle.hwOneRcdIterate}`}
              >
                <Table>
                  <TableBody>
                    <TableRow
                      className={TableStyle.contributionWrapper}
                      style={{ borderSpacing: "5px" }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        align="right"
                        style={{ width: "66.6%" }}
                        className="pdf-right"
                      >
                        Additional Contribution to{" "}
                        <span>
                          {
                            fringeExcessAllocationAdditionalDetails.name
                          }
                        </span>{" "}
                        from H&W
                      </TableCell>
                      <TableCell align="right">
                        {Utils.formatCurrency(fringeExcessAllocationAdditionalDetails.amount)}
                      </TableCell>
                    </TableRow>
                  // <br></br>
                  </TableBody>
                </Table>
              </TableContainer>
            );
          }
        )}



        {/* Contribution type Name '{fringeExcessAllocationAdditional[0].name}' */}
        <TableContainer
          className={`${TableStyle.hwOneRcd} ${TableStyle.ContributionWrapped}`}
        >
          <Table>
            <TableBody>
              {statementDetails.fringeContribution.map(
                (fringeContributionDetails) => {
                  return (
                    <TableRow>
                      <TableCell
                        component="th"
                        scope="row"
                        align="right"
                        style={{ width: "66.6%" }}
                        className="pdf-right"
                      >
                        {`${fringeContributionDetails.contributionTypeName} - ${fringeContributionDetails.typeName} at ${fringeContributionDetails.contributionRate}`}
                      </TableCell>
                      <TableCell align="right">
                        {Utils.formatCurrency(fringeContributionDetails.contributionAmount)}
                      </TableCell>
                    </TableRow>
                  );
                }
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* HOURLY CONTRIBUTION */}

        {statementDetails.outputDisplay.map(
          (outputDisplayDetails) => {
            if (
              // CHANGE CONDITION FOR EACH (ER and EE)
              outputDisplayDetails.erCost > 0 &&
              outputDisplayDetails.eeCost > 0
            ) {
              return (
                <TableContainer
                  className={TableStyle.hwTwoColWrapper}
                >
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          component="th"
                          scope="row"
                          align="right"
                          style={{ width: "66.6%" }}
                          className="pdf-right"
                        >
                          Employer Contribution to{" "}
                          {outputDisplayDetails.benefitName}
                        </TableCell>
                        <TableCell align="right">
                          {Utils.formatCurrency(outputDisplayDetails.erCost)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          component="th"
                          scope="row"
                          align="right"
                          style={{ width: "66.6%" }}
                          className="pdf-right"
                        >
                          Employee Contribution to{" "}
                          {outputDisplayDetails.benefitName}
                        </TableCell>
                        <TableCell align="right">
                          {Utils.formatCurrency(outputDisplayDetails.eeCost)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              );
            }
          }
        )}

        {/* Total Contribution*/}
        <TableContainer className={TableStyle.hwOneRcd}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  align="right"
                  style={{ width: "66.6%" }}
                  className="pdf-right"
                >
                  Total Contribution
                </TableCell>
                <TableCell align="right">
                  {Utils.formatCurrency(statementDetails.totalContribution)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {/* HOURBANK BALANCE */}
        {statementDetails.hourbankBalance.length > 0 ?
          <TableContainer className={TableStyle.hwThreeColRcdWrapper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "20%", textAlign: "center" }}>
                    Hourbank Type
                  </TableCell>
                  <TableCell style={{ width: "20%", textAlign: "center" }}>
                    Beginning Balance
                  </TableCell>
                  <TableCell style={{ width: "20%", textAlign: "center" }}>
                    Contribution
                  </TableCell>
                  <TableCell style={{ width: "20%", textAlign: "center" }}>
                    Deduction
                  </TableCell>
                  <TableCell style={{ width: "20%", textAlign: "center" }}>
                    Ending Balance
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* statementDetails.benefitCost.doDisplayEECost === true ?  */}
                {statementDetails.hourbankBalance.map(
                  (hourbankBalanceDetails) => {
                    return (
                      <TableRow>
                        <TableCell style={{ textAlign: "right" }}>
                          {hourbankBalanceDetails.hourbankTypeName}
                        </TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                          {Utils.formatCurrency(hourbankBalanceDetails.beginningHourbankBalance)}
                        </TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                          {Utils.formatCurrency(hourbankBalanceDetails.hourbankContribution)}
                        </TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                          {Utils.formatCurrency(hourbankBalanceDetails.hourbankTaken)}
                        </TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                          {Utils.formatCurrency(hourbankBalanceDetails.endingHourbankBalance)}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TableContainer>
        : null }
        {/* DISCLAIMER */}
        {statementDisclaimers.length > 0 ?
          <Grid container direction="column">
            <Grid item><Box border={1} borderColor="#ddd" align="center" fontWeight="fontWeightBold">Disclaimer</Box></Grid>
            <Grid item>
              <Box border={1} borderTop={0} borderColor="#ddd" fontStyle="italic">
                {statementDisclaimers.map(d => {
                  return (<p>{d}</p>)
                })}
              </Box>
            </Grid>
          </Grid> 
        : null }

      </div>
    );
}
export default HWStatementDetail;
